import { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";

const NAV = [
  { to: "/", label: "首页" },
  { to: "/topics", label: "事件解析" },
  { to: "/guide", label: "鉴别指南" },
  { to: "/faq", label: "常见问题" },
  { to: "/about", label: "关于我们" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    navigate(`/topics?q=${encodeURIComponent(q.trim())}`);
    setQ("");
  };

  const linkCls = ({ isActive }: { isActive: boolean }) =>
    `relative whitespace-nowrap py-2 text-sm font-medium transition-colors hover:text-primary-700 ${
      isActive ? "text-foreground-950" : "text-foreground-700"
    }`;

  return (
    <header
      className={`sticky top-0 z-40 border-b border-background-200/70 bg-background-50/90 backdrop-blur transition-shadow ${
        scrolled ? "shadow-sm" : ""
      }`}
    >
      {/* 顶部细条 */}
      <div className="hidden border-b border-background-100 bg-background-100 lg:block">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-1.5 text-xs text-foreground-600 md:px-6">
          <span className="inline-flex items-center gap-2">
            <i className="ri-focus-3-line text-primary-600" />
            辨真社 · 让每一条爆料都有出处
          </span>
          <span className="inline-flex items-center gap-5">
            <span className="inline-flex items-center gap-1.5">
              <span className="h-1.5 w-1.5 rounded-full bg-accent-500" />
              今日新增 3 条核验
            </span>
            <span>吃瓜有据 · 求证有道</span>
          </span>
        </div>
      </div>

      <nav className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2.5 py-3">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 font-heading text-lg font-black text-background-50">
            辨
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-xl font-black tracking-wide text-foreground-950">
              辨真社
            </span>
            <span className="text-[10px] tracking-widest text-foreground-500">
              BIANZHEN·求证观察
            </span>
          </span>
        </Link>

        <div className="hidden items-center gap-7 lg:flex">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} className={linkCls} end={n.to === "/"}>
              {n.label}
            </NavLink>
          ))}
        </div>

        <div className="hidden items-center gap-3 md:flex">
          <form onSubmit={submitSearch} className="relative">
            <i className="ri-search-line pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-base text-foreground-500" />
            <input
              value={q}
              onChange={(e) => setQ(e.target.value)}
              type="text"
              placeholder="搜索要核验的事件…"
              className="h-9 w-48 rounded-md border border-background-200 bg-background-50 pl-9 pr-3 text-sm text-foreground-900 outline-none transition-colors focus:border-secondary-400 lg:w-56"
            />
          </form>
          <Link
            to="/topics"
            className="inline-flex h-9 items-center justify-center whitespace-nowrap rounded-md bg-foreground-950 px-4 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800"
          >
            浏览全部核验
          </Link>
        </div>

        <button
          onClick={() => setOpen((v) => !v)}
          aria-label="打开菜单"
          className="flex h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-900 lg:hidden"
        >
          <i className={`text-xl ${open ? "ri-close-line" : "ri-menu-line"}`} />
        </button>
      </nav>

      {/* 移动端菜单 */}
      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 lg:hidden">
          <div className="flex flex-col">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                className={({ isActive }) =>
                  `rounded-md px-3 py-2.5 text-base font-medium ${
                    isActive
                      ? "bg-background-100 text-foreground-950"
                      : "text-foreground-700"
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
          </div>
          <form onSubmit={submitSearch} className="relative mt-3 md:hidden">
            <i className="ri-search-line pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-base text-foreground-500" />
            <input
              value={q}
              onChange={(e) => setQ(e.target.value)}
              type="text"
              placeholder="搜索要核验的事件…"
              className="h-11 w-full rounded-md border border-background-200 bg-background-50 pl-9 pr-3 text-sm outline-none"
            />
          </form>
        </div>
      )}
    </header>
  );
}